import React from "react";

const Name = ({ name }) => {
	return <h2>{name}</h2>;
};
export default Name;
